import Vue from 'vue'
import i18n from '@/lang'; // Internationalization
let vm = new Vue({
  i18n,
})

export default [
  {
    icon: 'home',
    componentName: 'dashboard',
    name: vm.$t('home'),
    isFrame: true,
  },
  {
    icon: 'users1',
    componentName: 'myCustomer',
    name: vm.$t('My_customer'),
    isFrame: true,
    children: [
      {
        icon: 'circle-XS',
        componentName: 'report_custom',
        name: vm.$t('Direct_customer_list'),
        isFrame: true,
      },
      {
        icon: 'circle-XS',
        componentName: 'report_subIb',
        name: vm.$t('User.reportSubibList'),
        isFrame: true,
      },
      {
        icon: 'circle-XS',
        componentName: 'accountList',
        name: vm.$t('User.accountList'),
        isFrame: true,
      },
    ]
  },

  {
      icon: 'dollar',
      componentName: 'agentFundsList',
      name: vm.$t('funds_list'),
      isFrame: true,
  },
  {
    icon: 'file-text1',
    componentName: 'agentTradeHistory',
    name: vm.$t('Transaction_history'),
    isFrame: true,
  },
  {
    icon: 'yongjinmingxi',
    componentName: 'commissionRecord',
    name: vm.$t('menu.Commission_details'),
    isFrame: true,
  },
  {
    icon: 'chuyongjilu',
    componentName: 'commissionOutRecord',
    name: vm.$t('User.reportCommiRecord'),
    isFrame: true,
  },
  {
    icon: 'pinzhongtongji',
    componentName: 'symbolStatistics',
    name: vm.$t('Symbol_Statistics'),
    isFrame: true,
  },
  {
    icon: 'yejitongji',
    componentName: 'performanceStatistics',
    name: vm.$t('Performance_Statistics'),
    isFrame: true,
  },
  {
    icon: 'user',
    componentName: 'files',
    name: vm.$t('My_profile'),
    isFrame: true,
    children:[
      {
        icon: 'circle-XS',
        componentName: 'personalInformation',
        name: vm.$t('personal_information'),
        isFrame: true,
      },
      {
        icon: 'circle-XS',
        componentName: 'collection',
        name: vm.$t('Billing_message'),
        isFrame: true,
      },
      {
        icon: 'circle-XS',
        componentName: 'securitySettings',
        name: vm.$t('security_settings'),
        isFrame: true,
      }
    ]
  },
  {
    icon: 'dollar',
    componentName: 'fundsManagement',
    name: vm.$t('funds_management'),
    isFrame: true,
    children:[
      {
        icon: 'circle-XS',
        componentName: 'depositFunds',
        name: vm.$t('Trade.deposit'),
        isFrame: true,
      },
      {
        icon: 'circle-XS',
        componentName: 'withdraw',
        name: vm.$t('Withdraw'),
        isFrame: true,
      },
      {
        icon: 'circle-XS',
        componentName: 'transfers',
        name: vm.$t('User.transferAccounts'),
        isFrame: true,
      },
      {
        icon: 'circle-XS',
        componentName: 'fundsList',
        name: vm.$t('funds_list'),
        isFrame: true,
      },
      {
        icon: 'circle-XS',
        componentName: 'auditList',
        name: vm.$t('audit_list'),
        isFrame: true,
      },
    ]
  },
  // 赠金记录
  // 两个表改成一个表格 todo
  {
    icon: 'bonus',
    componentName: 'bonusList',
    name: vm.$t('User.goldManage'),
    isFrame: true,
    /*children:[
      {
        icon: 'circle-XS',
        componentName: 'bonusList',
        name: vm.$t(''),
        isFrame: true,
      },
      {
        icon: 'circle-XS',
        componentName: 'turnList',
        name: vm.$t('withgold.TransferRecord'),
        isFrame: true,
      },
    ]*/
  },
  {
    icon: 'grid1',
    componentName: 'traderReport',
    name: vm.$t('trader_Report'),
    isFrame: true,
  },
  {
    icon: 'download-cloud',
    componentName: 'orderManage',
    name: vm.$t('Download_Center'),
    isFrame: true,
    children: [
      {
        icon: 'circle-XS',
        componentName: 'download',
        name: vm.$t('trading_software'),
        isFrame: true,
      },
      {
        icon: 'circle-XS',
        componentName: 'downloadFiles',
        name: vm.$t('Files'),
        isFrame: true,
      }
    ]
  },
  /*{
    icon: 'file-text1',
    componentName: 'wallet',
    name: '工单服务',
    nameEn: 'Ticket service',
    isFrame: true,
  },*/

  {
    icon: 'jifenshangcheng1',
    componentName: 'integralModule',
    name: vm.$t('integral_Shop'),
    isFrame: true,
    children: [
      {
        icon: 'circle-XS',
        componentName: 'integralShop',
        name: vm.$t('integral_Shop'),
        isFrame: true,
      },
      {
        icon: 'circle-XS',
        componentName: 'integralHome',
        name: vm.$t('Points_Details'),
        isFrame: true,
      },
    ]
  },
  {
    icon: 'copy1',
    componentName: 'copyMaster',
    name: 'CopyMaster',
    isFrame: true,
  },
  {
    icon: 'bell',
    componentName: 'message',
    name: vm.$t('announcement'),
    isFrame: true,
  },
  {
    icon: 'FAQ',
    componentName: 'faq',
    name: 'FAQ',
    isFrame: true,
  },

]
